import * as req from 'api/actions';
import * as c from './constant';

export const getNewFixedFeesList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_NEW_FIXED_FEES,
    'api/v1/bpls/administrator/tax_revenue/fixed_fees',
    payload,
    callback
  );

export const getSingleNewFixedFees = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_FIXED_FEES,
    `api/v1/bpls/administrator/tax_revenue/fixed_fees/${id}`,
    payload,
    callback
  );

export const createNewFixedFees = (payload, callback) =>
  req.create(
    c.CREATE_NEW_FIXED_FEES,
    'api/v1/bpls/administrator/tax_revenue/fixed_fees',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateNewFixedFees = (id, payload, callback) =>
  req.update(
    c.UPDATE_NEW_FIXED_FEES,
    `api/v1/bpls/administrator/tax_revenue/fixed_fees/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeNewFixedFees = (id, payload, callback) =>
  req.remove(
    c.REMOVE_NEW_FIXED_FEES,
    `api/v1/bpls/administrator/tax_revenue/fixed_fees/${id}`,
    payload,
    callback
  );
